import { render } from "./App.vue?vue&type=template&id=5f4fb082"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5f4fb082&lang=scss"

import exportComponent from "E:\\ALCON\\_DEV\\dhs-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__